import React, { lazy, Suspense, type ReactElement } from 'react'

import { Loader } from '../components/Loader'
import { useRequireAuth } from '../hooks/useRequireAuth'
import { updatePlatformHeader } from '../services/api/auth'
import { setPlatformForLogs } from '../services/datadog'

const LazyChangePasswordPage = lazy(() =>
  import('../pages/ChangePassword').then((module) => ({ default: module.ChangePasswordPage })),
)

export const ChangePasswordAndroidRoute = (): ReactElement => {
  const platform = 'android'

  updatePlatformHeader(platform)
  setPlatformForLogs(platform)

  const { isAuthenticated } = useRequireAuth()

  if (!isAuthenticated) {
    return <Loader />
  }

  return (
    <Suspense fallback={<Loader />}>
      <LazyChangePasswordPage showBackButton={false} />
    </Suspense>
  )
}
